<template>
	
<div class="segment">

	<div class="segment-head">

		<div class="segment-head-icon" :data-name="segment" v-if="!icon"></div>
		<div class="segment-head-icon" v-if="icon"><i class="fa-solid" :class="icon"></i></div>

		<div class="segment-head-main">
			<div class="segment-head-title" v-if="title">{{ title }}</div>
			<div class="segment-head-title" v-if="!title">{{ section[segment].title }}</div>
			<slot name="subtitle"></slot>
		</div>

		<div class="segment-head-close" v-on:click="$emit('close')"></div>

	</div>

	<div class="segment-content">

		<slot></slot>

	</div>

</div>

</template>

<script>

export default {

	props: ['segment', 'section', 'title', 'icon']
	
}

</script>

<style scoped>

.segment {
	padding: 32px;
	background-color: #f6f6f6;
	border-radius: 32px;
}

.segment-head {
	display: flex;
	align-items: center;
	margin-bottom: 32px;
}

.segment-head-icon {
	width: 84px;
	height: 84px;
	border-radius: 42px;
	background-color: var(--aid-color);
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-size: 48px auto;
}

.segment-head-icon[data-name="diet"] { background-image: url(~@/assets/aid/improve/icon.diet.svg); }
.segment-head-icon[data-name="treatment"] { background-image: url(~@/assets/aid/improve/icon.treatment.svg); }
.segment-head-icon[data-name="supplements"] { background-image: url(~@/assets/aid/improve/icon.supplements.svg); }
.segment-head-icon[data-name="stress"] { background-image: url(~@/assets/aid/improve/icon.stress.svg); }
.segment-head-icon[data-name="habits"] { background-image: url(~@/assets/aid/improve/icon.habits.svg); }
.segment-head-icon[data-name="activity"] { background-image: url(~@/assets/aid/improve/icon.activity.svg); }

.segment-head-main {
	flex-grow: 1;
	padding: 0px 32px;
}

.segment-head-title {
	color: #343434;
	font-size: 24px;
	font-weight: 600;
}

.segment-head-close {
	width: 42px;
	margin-top: -48px;
	background-color: var(--aid-color);
	border-radius: 21px;
	height: 42px;
	cursor: pointer;
	background-image: url(~@/assets/aid/improve/icon.close.svg);
	background-repeat: no-repeat;
	background-position: 50% 50%;
}

</style>